"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    background: prop_types_1.default.string,
    backgroundBlendMode: prop_types_1.default.string,
    backgroundClip: prop_types_1.default.string,
    backgroundColor: prop_types_1.default.string,
    backgroundImage: prop_types_1.default.string,
    backgroundOrigin: prop_types_1.default.string,
    backgroundPosition: prop_types_1.default.string,
    backgroundRepeat: prop_types_1.default.string,
    backgroundSize: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const background = {
    className: 'bg',
    cssName: 'background',
    jsName: 'background',
    isPrefixed: true,
    complexValue: true
};
const backgroundColor = {
    className: 'bg-clr',
    cssName: 'background-color',
    jsName: 'backgroundColor'
};
const backgroundImage = {
    className: 'bg-img',
    cssName: 'background-image',
    jsName: 'backgroundImage',
    isPrefixed: true,
    complexValue: true
};
const backgroundPosition = {
    className: 'bg-pos',
    cssName: 'background-position',
    jsName: 'backgroundPosition'
};
const backgroundSize = {
    className: 'bg-siz',
    cssName: 'background-size',
    jsName: 'backgroundSize'
};
const backgroundOrigin = {
    className: 'bg-orgn',
    cssName: 'background-origin',
    jsName: 'backgroundOrigin'
};
const backgroundRepeat = {
    className: 'bg-rpt',
    cssName: 'background-repeat',
    jsName: 'backgroundRepeat'
};
const backgroundClip = {
    className: 'bg-clp',
    cssName: 'background-clip',
    jsName: 'backgroundClip'
};
const backgroundBlendMode = {
    className: 'bg-blnd-md',
    cssName: 'background-blend-mode',
    jsName: 'backgroundBlendMode'
};
exports.propEnhancers = {
    background: (value) => get_css_1.default(background, value),
    backgroundBlendMode: (value) => get_css_1.default(backgroundBlendMode, value),
    backgroundClip: (value) => get_css_1.default(backgroundClip, value),
    backgroundColor: (value) => get_css_1.default(backgroundColor, value),
    backgroundImage: (value) => get_css_1.default(backgroundImage, value),
    backgroundOrigin: (value) => get_css_1.default(backgroundOrigin, value),
    backgroundPosition: (value) => get_css_1.default(backgroundPosition, value),
    backgroundRepeat: (value) => get_css_1.default(backgroundRepeat, value),
    backgroundSize: (value) => get_css_1.default(backgroundSize, value)
};
//# sourceMappingURL=data:application/json;base64,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